import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import MobileLayout from '../Components/Layout/MobileLayout';
import TabletLayout from '../Components/Layout/TabletLayout';
import LaptopLayout from '../Components/Layout/LaptopLayout';
import DesktopLayout from '../Components/Layout/DesktopLayout';

function Layout() {
  const location = useLocation();
  const [layout, setLayout] = useState({});
  const [mobileLayoutItems, setMobileLayoutItems] = useState([]);
  const [tabletLayoutItems, setTabletLayoutItems] = useState([]);
  const [laptopLayoutItems, setLaptopLayoutItems] = useState([]);
  const [desktopLayoutItems, setDesktopLayoutItems] = useState([]);

  let size = 'Mobile';

  if (window.innerWidth < 500) {
    size = 'Mobile';
  } else if (window.innerWidth >= 500 && window.innerWidth < 1024) {
    size = 'Tablet';
  } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    size = 'Laptop';
  } else if (window.innerWidth >= 1440) {
    size = 'Desktop';
  }
  const [currentSize, setCurrentSize] = useState(size);

  // Helper function to map layout items for mobile
  const mapMobileItems = (items) => {
    return items
      .filter(item => !item.hidden_mobile)
      .map((item) => ({
        id: item.id,
        type: item.type,
        text: item.text,
        mobileBackgroundColor: item.backgroundColor_mobile != null ? item.backgroundColor_mobile : item.backgroundColor,
        mobileForegroundColor: item.foregroundColor_mobile != null ? item.foregroundColor_mobile : item.foregroundColor,
        mobileFontSize: item.fontSize_mobile != null ? item.fontSize_mobile : item.fontSize,
        mobileHeight: (item.topActive_mobile != null ? item.topActive_mobile : item.topActive) && 
                     (item.bottomActive_mobile != null ? item.bottomActive_mobile : item.bottomActive) ? 
                     null : (item.height_mobile != null ? item.height_mobile : item.height),
        mobileWidth: (item.leftActive_mobile != null ? item.leftActive_mobile : item.leftActive) && 
                     (item.rightActive_mobile != null ? item.rightActive_mobile : item.rightActive) ? 
                     null : (item.width_mobile != null ? item.width_mobile : item.width),
        mobileLeft: (item.leftActive_mobile != null ? item.leftActive_mobile : item.leftActive) ? 
                    (item.leftConstant_mobile != null ? item.leftConstant_mobile : item.leftConstant) : null,
        mobileTop: (item.topActive_mobile != null ? item.topActive_mobile : item.topActive) ? 
                   (item.topConstant_mobile != null ? item.topConstant_mobile : item.topConstant) : null,
        mobileRight: (item.rightActive_mobile != null ? item.rightActive_mobile : item.rightActive) ? 
                     (item.rightConstant_mobile != null ? item.rightConstant_mobile : item.rightConstant) : null,
        mobileBottom: (item.bottomActive_mobile != null ? item.bottomActive_mobile : item.bottomActive) ? 
                      (item.bottomConstant_mobile != null ? item.bottomConstant_mobile : item.bottomConstant) : null,
        mobileZIndex: item.z_mobile != null ? item.z_mobile : item.z,
        source: item.source,
        mobileLeftItemId: item.leftItemId_mobile != null ? item.leftItemId_mobile : item.leftItemId,
        mobileRightItemId: item.rightItemId_mobile != null ? item.rightItemId_mobile : item.rightItemId,
        mobileTopItemId: item.topItemId_mobile != null ? item.topItemId_mobile : item.topItemId,
        mobileBottomItemId: item.bottomItemId_mobile != null ? item.bottomItemId_mobile : item.bottomItemId,
        mobileLeftActive: item.leftActive_mobile != null ? item.leftActive_mobile : item.leftActive,
        mobileRightActive: item.rightActive_mobile != null ? item.rightActive_mobile : item.rightActive,
        mobileTopActive: item.topActive_mobile != null ? item.topActive_mobile : item.topActive,
        mobileBottomActive: item.bottomActive_mobile != null ? item.bottomActive_mobile : item.bottomActive,
        mobileBorderWidth: item.borderWidth_mobile != null ? item.borderWidth_mobile : item.borderWidth,
        mobileBorderColor: item.borderColor_mobile != null ? item.borderColor_mobile : item.borderColor,
        mobileCornerRadius: item.cornerRadius_mobile != null ? item.cornerRadius_mobile : item.cornerRadius,
        appleMusicSongArtwork: item.appleMusicSongArtwork,
        appleMusicSongTitle: item.appleMusicSongTitle,
        appleMusicSongArtistName: item.appleMusicSongArtistName,
        appleMusicSongAlbumName: item.appleMusicSongAlbumName,
      }));
  };

  // Helper function to map layout items for tablet
  const mapTabletItems = (items) => {
    return items
      .filter(item => !item.hidden_tablet)
      .map((item) => ({
        id: item.id,
        type: item.type,
        text: item.text,
        backgroundColor: item.backgroundColor_tablet != null ? item.backgroundColor_tablet : item.backgroundColor,
        foregroundColor: item.foregroundColor_tablet != null ? item.foregroundColor_tablet : item.foregroundColor,
        fontSize: item.fontSize_tablet != null ? item.fontSize_tablet : item.fontSize,
        height: (item.topActive_tablet != null ? item.topActive_tablet : item.topActive) && 
                (item.bottomActive_tablet != null ? item.bottomActive_tablet : item.bottomActive) ? 
                null : (item.height_tablet != null ? item.height_tablet : item.height),
        width: (item.leftActive_tablet != null ? item.leftActive_tablet : item.leftActive) && 
               (item.rightActive_tablet != null ? item.rightActive_tablet : item.rightActive) ? 
               null : (item.width_tablet != null ? item.width_tablet : item.width),
        left: (item.leftActive_tablet != null ? item.leftActive_tablet : item.leftActive) ? 
              (item.leftConstant_tablet != null ? item.leftConstant_tablet : item.leftConstant) : null,
        top: (item.topActive_tablet != null ? item.topActive_tablet : item.topActive) ? 
             (item.topConstant_tablet != null ? item.topConstant_tablet : item.topConstant) : null,
        right: (item.rightActive_tablet != null ? item.rightActive_tablet : item.rightActive) ? 
               (item.rightConstant_tablet != null ? item.rightConstant_tablet : item.rightConstant) : null,
        bottom: (item.bottomActive_tablet != null ? item.bottomActive_tablet : item.bottomActive) ? 
                (item.bottomConstant_tablet != null ? item.bottomConstant_tablet : item.bottomConstant) : null,
        zIndex: item.z_tablet != null ? item.z_tablet : item.z,
        source: item.source,
        leftItemId: item.leftItemId_tablet != null ? item.leftItemId_tablet : item.leftItemId,
        rightItemId: item.rightItemId_tablet != null ? item.rightItemId_tablet : item.rightItemId,
        topItemId: item.topItemId_tablet != null ? item.topItemId_tablet : item.topItemId,
        bottomItemId: item.bottomItemId_tablet != null ? item.bottomItemId_tablet : item.bottomItemId,
        leftActive: item.leftActive_tablet != null ? item.leftActive_tablet : item.leftActive,
        rightActive: item.rightActive_tablet != null ? item.rightActive_tablet : item.rightActive,
        topActive: item.topActive_tablet != null ? item.topActive_tablet : item.topActive,
        bottomActive: item.bottomActive_tablet != null ? item.bottomActive_tablet : item.bottomActive,
        borderWidth: item.borderWidth_tablet != null ? item.borderWidth_tablet : item.borderWidth,
        borderColor: item.borderColor_tablet != null ? item.borderColor_tablet : item.borderColor,
        cornerRadius: item.cornerRadius_tablet != null ? item.cornerRadius_tablet : item.cornerRadius,
        appleMusicSongArtwork: item.appleMusicSongArtwork,
        appleMusicSongTitle: item.appleMusicSongTitle,
        appleMusicSongArtistName: item.appleMusicSongArtistName,
        appleMusicSongAlbumName: item.appleMusicSongAlbumName,
      }));
  };

  // Helper function to map layout items for laptop
  const mapLaptopItems = (items) => {
    return items
      .filter(item => !item.hidden_laptop)
      .map((item) => ({
        id: item.id,
        type: item.type,
        text: item.text,
        backgroundColor: item.backgroundColor_laptop != null ? item.backgroundColor_laptop : item.backgroundColor,
        foregroundColor: item.foregroundColor_laptop != null ? item.foregroundColor_laptop : item.foregroundColor,
        fontSize: item.fontSize_laptop != null ? item.fontSize_laptop : item.fontSize,
        height: (item.topActive_laptop != null ? item.topActive_laptop : item.topActive) && 
                (item.bottomActive_laptop != null ? item.bottomActive_laptop : item.bottomActive) ? 
                null : (item.height_laptop != null ? item.height_laptop : item.height),
        width: (item.leftActive_laptop != null ? item.leftActive_laptop : item.leftActive) && 
               (item.rightActive_laptop != null ? item.rightActive_laptop : item.rightActive) ? 
               null : (item.width_laptop != null ? item.width_laptop : item.width),
        left: (item.leftActive_laptop != null ? item.leftActive_laptop : item.leftActive) ? 
              (item.leftConstant_laptop != null ? item.leftConstant_laptop : item.leftConstant) : null,
        top: (item.topActive_laptop != null ? item.topActive_laptop : item.topActive) ? 
             (item.topConstant_laptop != null ? item.topConstant_laptop : item.topConstant) : null,
        right: (item.rightActive_laptop != null ? item.rightActive_laptop : item.rightActive) ? 
               (item.rightConstant_laptop != null ? item.rightConstant_laptop : item.rightConstant) : null,
        bottom: (item.bottomActive_laptop != null ? item.bottomActive_laptop : item.bottomActive) ? 
                (item.bottomConstant_laptop != null ? item.bottomConstant_laptop : item.bottomConstant) : null,
        zIndex: item.z_laptop != null ? item.z_laptop : item.z,
        source: item.source,
        leftItemId: item.leftItemId_laptop != null ? item.leftItemId_laptop : item.leftItemId,
        rightItemId: item.rightItemId_laptop != null ? item.rightItemId_laptop : item.rightItemId,
        topItemId: item.topItemId_laptop != null ? item.topItemId_laptop : item.topItemId,
        bottomItemId: item.bottomItemId_laptop != null ? item.bottomItemId_laptop : item.bottomItemId,
        leftActive: item.leftActive_laptop != null ? item.leftActive_laptop : item.leftActive,
        rightActive: item.rightActive_laptop != null ? item.rightActive_laptop : item.rightActive,
        topActive: item.topActive_laptop != null ? item.topActive_laptop : item.topActive,
        bottomActive: item.bottomActive_laptop != null ? item.bottomActive_laptop : item.bottomActive,
        borderWidth: item.borderWidth_laptop != null ? item.borderWidth_laptop : item.borderWidth,
        borderColor: item.borderColor_laptop != null ? item.borderColor_laptop : item.borderColor,
        cornerRadius: item.cornerRadius_laptop != null ? item.cornerRadius_laptop : item.cornerRadius,
        appleMusicSongArtwork: item.appleMusicSongArtwork,
        appleMusicSongTitle: item.appleMusicSongTitle,
        appleMusicSongArtistName: item.appleMusicSongArtistName,
        appleMusicSongAlbumName: item.appleMusicSongAlbumName,
      }));
  };

  // Helper function to map layout items for desktop
  const mapDesktopItems = (items) => {
    return items
      .filter(item => !item.hidden_desktop)
      .map((item) => ({
        id: item.id,
        type: item.type,
        text: item.text,
        backgroundColor: item.backgroundColor_desktop != null ? item.backgroundColor_desktop : item.backgroundColor,
        foregroundColor: item.foregroundColor_desktop != null ? item.foregroundColor_desktop : item.foregroundColor,
        fontSize: item.fontSize_desktop != null ? item.fontSize_desktop : item.fontSize,
        height: (item.topActive_desktop != null ? item.topActive_desktop : item.topActive) && 
                (item.bottomActive_desktop != null ? item.bottomActive_desktop : item.bottomActive) ? 
                null : (item.height_desktop != null ? item.height_desktop : item.height),
        width: (item.leftActive_desktop != null ? item.leftActive_desktop : item.leftActive) && 
               (item.rightActive_desktop != null ? item.rightActive_desktop : item.rightActive) ? 
               null : (item.width_desktop != null ? item.width_desktop : item.width),
        left: (item.leftActive_desktop != null ? item.leftActive_desktop : item.leftActive) ? 
              (item.leftConstant_desktop != null ? item.leftConstant_desktop : item.leftConstant) : null,
        top: (item.topActive_desktop != null ? item.topActive_desktop : item.topActive) ? 
             (item.topConstant_desktop != null ? item.topConstant_desktop : item.topConstant) : null,
        right: (item.rightActive_desktop != null ? item.rightActive_desktop : item.rightActive) ? 
               (item.rightConstant_desktop != null ? item.rightConstant_desktop : item.rightConstant) : null,
        bottom: (item.bottomActive_desktop != null ? item.bottomActive_desktop : item.bottomActive) ? 
                (item.bottomConstant_desktop != null ? item.bottomConstant_desktop : item.bottomConstant) : null,
        zIndex: item.z_desktop != null ? item.z_desktop : item.z,
        source: item.source,
        leftItemId: item.leftItemId_desktop != null ? item.leftItemId_desktop : item.leftItemId,
        rightItemId: item.rightItemId_desktop != null ? item.rightItemId_desktop : item.rightItemId,
        topItemId: item.topItemId_desktop != null ? item.topItemId_desktop : item.topItemId,
        bottomItemId: item.bottomItemId_desktop != null ? item.bottomItemId_desktop : item.bottomItemId,
        leftActive: item.leftActive_desktop != null ? item.leftActive_desktop : item.leftActive,
        rightActive: item.rightActive_desktop != null ? item.rightActive_desktop : item.rightActive,
        topActive: item.topActive_desktop != null ? item.topActive_desktop : item.topActive,
        bottomActive: item.bottomActive_desktop != null ? item.bottomActive_desktop : item.bottomActive,
        borderWidth: item.borderWidth_desktop != null ? item.borderWidth_desktop : item.borderWidth,
        borderColor: item.borderColor_desktop != null ? item.borderColor_desktop : item.borderColor,
        cornerRadius: item.cornerRadius_desktop != null ? item.cornerRadius_desktop : item.cornerRadius,
        appleMusicSongArtwork: item.appleMusicSongArtwork,
        appleMusicSongTitle: item.appleMusicSongTitle,
        appleMusicSongArtistName: item.appleMusicSongArtistName,
        appleMusicSongAlbumName: item.appleMusicSongAlbumName,
      }));
  };

  useEffect(() => {
    const segments = location.pathname.split('/');
    const last = segments.pop() || segments.pop(); // Handle potential trailing slash
    // const baseUrl = "http://localhost:3000"; // Local
    // const baseUrl = "htp://192.168.1.206:3000"; // Accessing via device
    const baseUrl = "https://test.curatelife.app"; // Test
    // const baseUrl = "https://dev.curatelife.app"; // Dev
    const layoutItemsUrl = `${baseUrl}/api/app/layoutItems/layout/${last}`;

    axios.get(layoutItemsUrl).then((res) => {
      const layout = res.data.layout;
      setLayout(layout);
      const rawItems = res.data.layoutItems;

      // Create mapped items for each screen size
      setMobileLayoutItems(mapMobileItems(rawItems));
      setTabletLayoutItems(mapTabletItems(rawItems));
      setLaptopLayoutItems(mapLaptopItems(rawItems));
      setDesktopLayoutItems(mapDesktopItems(rawItems));
    });

    function handleResize() {
      // do magic for resize
      console.log('resized to: ', window.innerWidth);

      if (window.innerWidth < 500) {
        setCurrentSize('Mobile');
      } else if (window.innerWidth >= 500 && window.innerWidth < 1024) {
        setCurrentSize('Tablet');
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        setCurrentSize('Laptop');
      } else if (window.innerWidth >= 1440) {
        setCurrentSize('Desktop');
      }
    }
     
     window.addEventListener('resize', handleResize);
  }, [location.pathname]);

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: layout.backgroundColor ? `#${layout.backgroundColor}` : '#ffffff',
      position: 'relative',
      top: 0,
      left: 0
    }}>
      {(() => {
        switch (currentSize) {
          case 'Mobile':
            return <MobileLayout layoutItems={mobileLayoutItems} layout={layout} />
          case 'Tablet':
            return <TabletLayout layoutItems={tabletLayoutItems} layout={layout} />
          case 'Laptop':
            return <LaptopLayout layoutItems={laptopLayoutItems} layout={layout} />
          case 'Desktop':
            return <DesktopLayout layoutItems={desktopLayoutItems} layout={layout} />
          default:
            return <MobileLayout layoutItems={mobileLayoutItems} layout={layout} />
        }
      })()}
    </div>
  );
}

export default Layout;
